<template>
  <div class="home">
    <Cube></Cube>
    <!-- <Hero /> -->
    <!-- <SvgLogoCube class="header__logo"></SvgLogoCube> -->
    <h1 class="home__headline">
      METAWERKS
    </h1>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Cube from "@/components/Cube.vue"
  // import Hero from "@/components/Hero.vue"
  // import SvgLogoCube from "@/components/svg/SvgLogoCube.vue"

  export default {
    name: "Home",
    components: {
      // Hero,
      // SvgLogoCube,
      Cube,
    },
    mounted() {
      document.body.classList.add("body__home")
    },
    destroyed() {
      document.body.classList.remove("body__home")
    },
  }
</script>

<style lang="scss">
  @import "./src/scss/style--light";

  .body__home #app {
    padding: 0;
    width: 100%;
    max-width: 100%;
    height: 100vh;
    overflow: hidden;
    margin-top: 0;
    background-color: #121212;
    background-image: none;
  }

  .home__headline {
    letter-spacing: 0.25rem;
    font-size: 0.75rem;
    font-weight: 400;
    color: #a8b4ce;
    text-align: center;
    width: 10rem;
    height: 10rem;
    display: flex;
    position: absolute;
    top: 49.25%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2rem 1rem;
    background-color: #121212;
  }

  .body__home .header__logo {
    text-align: center;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    top: calc(50% - 110px);
    left: calc(50% - 35px);

    min-width: 70px;
    width: 70px;
  }
</style>
